const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/communities.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/communities")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    search: z.string().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "{erg_p}",
      description: "Page title"
    })
  }
});